module.exports = __webpack_public_path__ + "static/media/dd0d0cc6.jpg";